<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-07-07 14:35:37
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-07-08 11:38:24
-->
<template>
  <div class="circle-wrapper">
    <div class="circle-content">
        <van-sidebar v-model="active" @change="handleChange" style="flex-shrink:0;">
          <van-sidebar-item title="关注的圈子" />
          <van-sidebar-item title="全部圈子" />
        </van-sidebar>
        <div style="width:100%;">
          <van-search
            v-model="name"
            @input="handleSearch"
            shape="round"
            clearable
            class="search-input"
            placeholder="请输入关键词搜索" />
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            class="list"
          >
            <div v-if="list.length">
              <div v-for="item in list" :key="item.id" class="list-item">
                <div @click="handleSelectItem(item)" class="item-info van-hairline--bottom">
                  <div style="display:flex;align-items:center;">
                    <van-image
                      round
                      width="1rem"
                      height="1rem"
                      class="item-avatar"
                      :src="item.iconUrl"
                    />
                    <span>{{item.name}}</span>
                  </div>
                  <van-icon v-if="item.show" name="success" color="#2695F1" />
                </div>
              </div>
            </div>
            <van-empty v-else description="暂无数据" />
          </van-list>
        </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/index'
import { Toast } from 'vant'
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      active: 0,
      name: '',
      list: [],
      loading: false,
      finished: false,
      pageParams: {
        current: 1,
        pageSize: 100
      }
    }
  },
  created() {
    this.fetchCircleList()
  },
  computed: {
    ...mapState(['selectCircle'])
  },
  methods: {
    ...mapMutations(['updateSelectCircle']),
    fetchCircleList() {
      this.loading = true
      const params = { ...this.pageParams, name: this.name }
      if (this.active === 0) {
        params.myFavor = 1
      }
      api.getMyCircle(params).then(res => {
        this.loading = false
        const { code, data, totalCount } = res
        if (code === 200) {
          if (this.pageParams.page > 1) {
            this.list = this.list.concat(data)
          } else {
            this.list = data
          }
          if (this.list.length >= totalCount) {
            this.finished = true
          }
        }
      })
    },
    handleChange() {
       this.updateSelectCircle([])
      this.name = ''
      this.fetchCircleList()
    },
    handleSearch() {
      this.pageParams.page = 1
      this.fetchCircleList()
    },
    onLoad() {
      this.pageParams.page++
      this.fetchCircleList()
    },
    handleSelectItem(item) {
      const id = item.id
      if (this.selectCircle.find(i => i.id === id)) {
        const selectList = this.selectCircle.filter(i => i.id !== id)
        this.updateSelectCircle(selectList)
        this.list = this.list.map(i => {
          if (i.id === id) {
            i.show = false
          }
          return i
        })
      } else {
        if (this.selectCircle.length === 3) {
          Toast.fail('最多能选3个圈子')
          return
        }
        this.updateSelectCircle([...this.selectCircle, item])
        this.list = this.list.map(i => {
          if (i.id === id) {
            i.show = true
          }
          return i
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.circle-wrapper {
  background: #fff;
  height: 80vh;
  width: 100%;
  overflow: hidden;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  .circle-content {
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  .list {
    height: 100%;
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    padding-bottom: 50px;
  }
  .item-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    // width: 100%;
    .item-avatar {
      margin-right: 10px;
    }
  }
  /deep/ .van-sidebar {
    width: 100px;
    height: 100vh;
    background: #f7f8fa;
  }
  /deep/ .van-sidebar-item--select {
    background-color: #f7f8fa;
  }
}
</style>